(() => {
const ready = (callback) => {
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', callback, { once: true });
} else {
callback();
}
};
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const formApiBase = 'https://l1no-oracle-ritual.pyg-a.chatgpt.site';
const nativeSubmissionKey = 'l1no-native-form-submission-v1';
function createSubmissionId() {
if (window.crypto?.randomUUID) return window.crypto.randomUUID();
const bytes = new Uint8Array(16);
window.crypto.getRandomValues(bytes);
bytes[6] = (bytes[6] & 0x0f) | 0x40;
bytes[8] = (bytes[8] & 0x3f) | 0x80;
const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function formValue(form, name) {
const field = form.elements.namedItem(name);
return typeof field?.value === 'string' ? field.value.trim() : '';
}
function submissionKind(form) {
if (form.dataset.l1noFormKind) return form.dataset.l1noFormKind;
return {
contact: 'contact',
coaching: 'coaching_apply',
waitlist: 'refuel_waitlist',
}[form.dataset.l1noForm] || '';
}
function submissionPayload(form, kind) {
const email = formValue(form, 'contact[email]');
if (kind === 'refuel_waitlist' || kind === 'iv_updates') return { email };
if (kind === 'coaching_apply') {
return {
name: formValue(form, 'contact[name]'),
email,
phone: formValue(form, 'contact[phone]'),
bestTime: formValue(form, 'contact[Best time to call]'),
format: formValue(form, 'contact[Coaching format]'),
message: formValue(form, 'contact[body]'),
};
}
return {
name: formValue(form, 'contact[name]'),
email,
topic: formValue(form, 'contact[topic]'),
message: formValue(form, 'contact[body]'),
};
}
function storeNativeSubmission(snapshot) {
try {
window.sessionStorage.setItem(nativeSubmissionKey, JSON.stringify(snapshot));
} catch {
// Shopify remains the primary record if session storage is unavailable.
}
}
function readNativeSubmission() {
try {
const stored = window.sessionStorage.getItem(nativeSubmissionKey);
return stored ? JSON.parse(stored) : null;
} catch {
return null;
}
}
function clearNativeSubmission() {
try {
window.sessionStorage.removeItem(nativeSubmissionKey);
} catch {
// Nothing to clear when storage is unavailable.
}
}
function addSubmissionTag(form, kind, submissionId) {
const tags = form.elements.namedItem('contact[tags]');
if (!tags || typeof tags.value !== 'string') return '';
const tag = `L1NO-Submission-${kind}-${submissionId.replaceAll('-', '')}`;
const values = tags.value.split(',').map((value) => value.trim()).filter(Boolean);
if (!values.includes(tag)) values.push(tag);
tags.value = values.join(', ');
return tag;
}
async function saveSubmission(form, kind, submissionId) {
const response = await window.fetch(`${formApiBase}/api/submissions`, {
method: 'POST',
headers: { 'content-type': 'application/json' },
body: JSON.stringify({
action: 'prepare',
submissionId,
kind,
payload: submissionPayload(form, kind),
marketingOptIn: form.dataset.l1noMarketingOptIn === 'true'
|| form.elements.namedItem('l1no_marketing_consent')?.checked === true,
sourcePath: `${window.location.pathname}${window.location.search}`,
website: formValue(form, 'website'),
}),
});
const result = await response.json().catch(() => ({}));
if (!response.ok) throw new Error(result.message || 'We could not save this just now. Please try again.');
return result;
}
async function confirmSubmission(snapshot) {
const delays = [0, 800, 2500];
let lastError = new Error('Confirmation failed');
for (const delay of delays) {
if (delay) await new Promise((resolve) => window.setTimeout(resolve, delay));
try {
const response = await window.fetch(`${formApiBase}/api/submissions`, {
method: 'POST',
headers: { 'content-type': 'application/json' },
body: JSON.stringify({ action: 'confirm', submissionId: snapshot.submissionId }),
keepalive: true,
});
if (!response.ok) throw new Error('Confirmation failed');
clearNativeSubmission();
return;
} catch (error) {
lastError = error instanceof Error ? error : lastError;
}
}
throw lastError;
}
function fieldMessage(field) {
if (field.type === 'email' && !emailPattern.test(field.value.trim())) {
return 'Enter a complete email address.';
}
if (field.type === 'tel') {
const digits = field.value.replace(/\D/g, '');
if (digits.length < 7 || digits.length > 20) return 'Enter a complete phone number.';
}
if (field.type === 'checkbox' && !field.checked) {
return 'Confirm that we may send this requested update.';
}
if (field.type === 'radio') {
const group = field.form.querySelectorAll(`input[type="radio"][name="${CSS.escape(field.name)}"]`);
if (![...group].some((radio) => radio.checked)) {
return 'Choose the coaching format you are considering.';
}
return '';
}
if (!field.value.trim()) {
if (field.name === 'contact[Best time to call]') return 'Tell us when you would prefer to be called.';
if (field.name === 'contact[body]') return 'Tell us why you are reaching out now.';
if (field.name === 'contact[topic]') return 'Choose a topic.';
return 'Complete this field.';
}
return '';
}
function initializeForms() {
document.querySelectorAll('form[data-l1no-form]').forEach((form) => {
form.noValidate = true;
const status = form.querySelector('[data-form-status]');
const submit = form.querySelector('[type="submit"]');
const submitLabel = submit?.dataset.submitLabel || submit?.textContent.trim() || 'Submit';
const requiredFields = Array.from(form.querySelectorAll('[required]'));
const errorElementFor = (field) => {
return form.querySelector(`[data-field-error="${CSS.escape(field.name)}"]`);
};
const clearError = (field) => {
field.removeAttribute('aria-invalid');
const errorElement = errorElementFor(field);
if (errorElement) {
errorElement.textContent = '';
errorElement.hidden = true;
}
};
const showError = (field, message) => {
field.setAttribute('aria-invalid', 'true');
const errorElement = errorElementFor(field);
if (errorElement) {
errorElement.textContent = message;
errorElement.hidden = false;
const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
describedBy.add(errorElement.id);
field.setAttribute('aria-describedby', [...describedBy].join(' '));
}
};
const validate = () => {
const errors = [];
const processedRadioGroups = new Set();
requiredFields.forEach((field) => {
if (field.type === 'radio') {
if (processedRadioGroups.has(field.name)) return;
processedRadioGroups.add(field.name);
}
const message = fieldMessage(field);
if (message) {
showError(field, message);
errors.push({ field, message });
} else {
clearError(field);
}
});
if (!status) return errors;
if (!errors.length) {
status.hidden = true;
return errors;
}
const items = errors
.map(({ field, message }) => `<li><a href="#${field.id}">${message}</a></li>`)
.join('');
status.dataset.state = 'error';
status.setAttribute('role', 'alert');
status.setAttribute('tabindex', '-1');
status.innerHTML = `<p class="form-status-title">Check the highlighted fields.</p><ul>${items}</ul>`;
status.hidden = false;
status.focus();
return errors;
};
requiredFields.forEach((field) => {
const eventName = field.type === 'checkbox' || field.type === 'radio' || field.tagName === 'SELECT'
? 'change'
: 'input';
field.addEventListener(eventName, () => {
if (!fieldMessage(field)) clearError(field);
});
});
form.addEventListener('submit', async (event) => {
if (form.dataset.l1noNativeReady === 'true') {
form.setAttribute('aria-busy', 'true');
return;
}
const errors = validate();
if (errors.length) {
event.preventDefault();
return;
}
event.preventDefault();
event.stopImmediatePropagation();
form.setAttribute('aria-busy', 'true');
if (submit) {
submit.disabled = true;
submit.textContent = 'Saving…';
}
const kind = submissionKind(form);
const submissionId = form.dataset.l1noSubmissionId || createSubmissionId();
form.dataset.l1noSubmissionId = submissionId;
let nativeSubmitStarted = false;
try {
await saveSubmission(form, kind, submissionId);
const receiptTag = addSubmissionTag(form, kind, submissionId);
storeNativeSubmission({
formId: form.id,
kind,
submissionId,
receiptTag,
});
form.dataset.l1noNativeReady = 'true';
if (submit) {
submit.textContent = form.dataset.l1noForm === 'waitlist' ? 'Submitting…' : 'Sending…';
}
nativeSubmitStarted = true;
form.requestSubmit();
window.L1NOFormCaptchaWatch?.(form, submit, submitLabel);
} catch (error) {
form.removeAttribute('aria-busy');
if (submit) {
submit.disabled = false;
submit.textContent = submitLabel;
}
if (status) {
status.dataset.state = 'error';
status.setAttribute('role', 'alert');
status.setAttribute('tabindex', '-1');
status.textContent = error.message || 'We could not save this just now. Please try again.';
status.hidden = false;
status.focus();
}
} finally {
if (!nativeSubmitStarted) delete form.dataset.l1noNativeReady;
}
});
if (status && !status.hidden) {
status.focus();
}
const pending = readNativeSubmission();
if (
status?.dataset.state === 'success' &&
pending?.submissionId &&
(!pending.formId || pending.formId === form.id)
) {
void confirmSubmission(pending).catch(() => undefined);
}
});
}
function initializeCoachingSelection() {
const fieldset = document.querySelector('[data-coaching-format]');
if (!fieldset) return;
const requested = new URLSearchParams(window.location.search).get('coaching');
if (!['monthly', 'return', 'unsure'].includes(requested)) return;
const input = fieldset.querySelector(`[data-format="${CSS.escape(requested)}"]`);
if (input) input.checked = true;
}
ready(() => {
initializeCoachingSelection();
initializeForms();
});
})();
